// src/App.js
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, VerifyEmailProvider } from './auth/AuthContext';
// import UserInfoFormPage from './pages/UserInfoFormPage';
// import PhoneConfirmPage from './pages/PhoneConfirmPage';
// import OtpInputPage from './pages/OtpInputPage';
// import ConsentPage from './pages/ConsentPage';
// import EConsentErrorPage from './pages/ErrorPage';
import EmailFormPage from './pages/ebilling/EmailFormPage';
import OtpVerificationPage from './pages/ebilling/OtpVerificationPage';
import EBillingConsentPage from './pages/ebilling/ConsentPage';
import ErrorPage from './pages/ebilling/ErrorPage';
import QrCodeGenerator from './pages/QrCodeGenerator';
import TermPage from './pages/ebilling/TermPage';


// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <VerifyEmailProvider>
          <BrowserRouter>
            <Routes>
              {/* Original feature routes */}
              {/* <Route path="/e-consent" element={<UserInfoFormPage />} />
              <Route path="/e-consent/phone-confirm" element={<PhoneConfirmPage />} />
              <Route path="/e-consent/otp-input" element={<OtpInputPage />} />
              <Route path="/e-consent/consent-form" element={<ConsentPage />} />
              <Route path="/e-consent/error" element={<EConsentErrorPage />} />
              <Route path="/e-consent/" element={<UserInfoFormPage />} /> */}

              {/* E-billing feature routes */}
              <Route path="/" element={<EmailFormPage />} />
              <Route path="/verify-email" element={<OtpVerificationPage />} />
              <Route path="/consent" element={<EBillingConsentPage />} />
              <Route path="/close" element={<ErrorPage />} />
              <Route path="/term" element={<TermPage />} />
              <Route path="*" element={<EmailFormPage />} />
              <Route path="/qr-code" element={<QrCodeGenerator />} />
            </Routes>
          </BrowserRouter>
        </VerifyEmailProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

